import { useEffect, useState } from "react";
import { Modal, Button, Group, Stack, Text } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { parseBackendDate } from "../../lib/format";
import { toDdMmYyyy } from "./licenseExpiry";

/**
 * Asked for when an admin approves a driver licence that has no expiry on file.
 * Drivers stopped entering the expiry themselves, and without one the
 * document-expiry job has nothing to warn about — so approval has to collect it.
 */
export function LicenseExpiryModal({
  opened,
  onClose,
  loading,
  onConfirm,
}: {
  opened: boolean;
  onClose: () => void;
  loading: boolean;
  onConfirm: (licenseExpiryDate: string) => void;
}) {
  const [expiry, setExpiry] = useState<Date | null>(null);

  useEffect(() => {
    if (opened) setExpiry(null);
  }, [opened]);

  const value = toDdMmYyyy(expiry);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Approve driver licence"
      centered
    >
      <Stack>
        <Text size="sm" c="dimmed">
          Read the expiry date off the uploaded licence. It drives the renewal
          reminders, so the licence cannot be approved without it.
        </Text>
        <DateInput
          label="Licence expiry"
          placeholder="DD-MM-YYYY"
          value={expiry}
          onChange={(d) => setExpiry(parseBackendDate(d as Date | string | null))}
          minDate={new Date()}
          required
        />
        <Group justify="flex-end">
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button
            color="green"
            loading={loading}
            disabled={!value}
            onClick={() => value && onConfirm(value)}
          >
            Approve licence
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
